import Tag from '@space-core/components/tag'
import useTranslation from '@space-core/hooks/useTranslation'
import LockIcon from '@space-shell/common/components/lockIcon'
import type { Product } from '@space-shell/common/services/sections'
import { getProductCoupon } from '@space-shell/modules/products/utils/productCoupon'

import clsx from 'clsx'
import styled from 'styled-components'

type TagsContainerProps = {
  product: Product
  className?: string
}

const Container = styled.div`
  z-index: 3;
  top: var(--spacer-3);
  left: var(--spacer-3);
  width: 100%;
  padding-right: 1.5rem;
`

const DiscountTag = styled(Tag)`
  background-color: var(--green);
  color: white;
  font-size: 0.8rem;
  border-radius: 0.25rem;
  height: 2rem;
`

const TagsContainer = ({ product, className }: TagsContainerProps) => {
  const { freeSignUp, purchased, joined } = product
  const coupon = getProductCoupon(product)
  const { t } = useTranslation()

  if ((purchased || joined) && !coupon) {
    return null
  }

  const couponTag = () => {
    if (!coupon || coupon < 0) {
      return null
    }

    return (
      <DiscountTag size='sm' role='term' data-test='coupon-tag'>
        {`-${coupon}%`}
      </DiscountTag>
    )
  }

  return (
    <Container className={clsx('_position-absolute', className)}>
      {freeSignUp ? (
        <div className='_d-flex _justify-content-between'>
          <Tag size='sm' variation='green' role='term'>
            {t('home.try_free')}
          </Tag>
          {couponTag()}
        </div>
      ) : (
        <div
          className={clsx('_d-flex _justify-content-end', {
            '_justify-content-between': !joined
          })}>
          {!joined && <LockIcon />}
          {couponTag()}
        </div>
      )}
    </Container>
  )
}

export default TagsContainer
